var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","background":"#eff1f6"},attrs:{"id":"projectdiv"}},[_c('el-main',{staticClass:"main",staticStyle:{"height":"100%","padding":"0px"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }